import { useState } from "react";

/**
 * 任务选择相关状态 Hook
 */
const useTaskSelectionState = () => {
  const [FlowName, setFlowName] = useState("new_user_first_experience");
  const [availableFlowTypes, setAvailableFlowTypes] = useState([
    { name: "default", displayName: "默认流程" }
  ]);
  const [taskSelectionDialog, setTaskSelectionDialog] = useState({
    open: false,
    isRestore: false,
    isUserModification: false,
    updateId: null
  });
  const [originalTaskList, setOriginalTaskList] = useState({
    software: [],
    hardware: []
  });
  const [userSelection, setUserSelection] = useState({
    software: [],
    hardware: []
  });
  const [showTaskButton, setShowTaskButton] = useState(false);

  // 重置任务选择状态
  const resetTaskSelectionState = () => {
    setFlowName("new_user_first_experience");
    setAvailableFlowTypes([{ name: "default", displayName: "默认流程" }]);
    setTaskSelectionDialog({
      open: false,
      isRestore: false,
      isUserModification: false,
      updateId: null
    });
    setOriginalTaskList({ software: [], hardware: [] });
    setUserSelection({ software: [], hardware: [] });
    setShowTaskButton(false);
  };

  return {
    FlowName,
    setFlowName,
    availableFlowTypes,
    setAvailableFlowTypes,
    taskSelectionDialog,
    setTaskSelectionDialog,
    originalTaskList,
    setOriginalTaskList,
    userSelection,
    setUserSelection,
    showTaskButton,
    setShowTaskButton,
    resetTaskSelectionState,
  };
};

export default useTaskSelectionState;
